import { styled } from "styled-components";

import {
    BIG_NAV_PX_HEIGHT,
    SMALL_NAV_PX_HEIGHT,
    colorCSS,
    colorCSSforSVG,
    fontSizes,
    minWidth,
    radius
} from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

const borderCSS = `1px solid ${colorCSS("N40")}`;
const svgG300 = colorCSSforSVG("G300");
const svgN100 = colorCSSforSVG("N100");
const svgN400 = colorCSSforSVG("N400");

export const SearchInput = styled.input`
    ${redundantCssFromKebab("background-color", `${colorCSS("N10")}`)}
    ${redundantCssFromKebab(
        "background-image",
        `url("data:image/svg+xml,%3Csvg fill='${svgN400}' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m0 0h24v24h-24z' fill='none'/%3E%3Cpath d='m16.436 15.085 3.94 4.01c.1765.1908.2718.4428.2657.7026s-.1131.5071-.2984.6893c-.1853.1823-.4342.2853-.6941.2872s-.5103-.0975-.6982-.2771l-3.938-4.006c-1.5195 1.1446-3.4171 1.6691-5.30872 1.4672s-3.63583-1.1151-4.87946-2.5546c-1.24364-1.4396-1.89376-3.2979-1.81874-5.1988.07503-1.90089.8696-3.70223 2.22283-5.03929s3.16399-2.10993 5.06559-2.16211c1.9017-.05217 3.7521.62024 5.1766 1.88108 1.4245 1.26085 2.3167 3.01591 2.4958 4.90981.1792 1.89391-.3681 3.78511-1.5309 5.29071zm-5.936.915c1.4587 0 2.8576-.5795 3.8891-1.6109 1.0314-1.0315 1.6109-2.4304 1.6109-3.8891 0-1.45869-.5795-2.85764-1.6109-3.88909-1.0315-1.03145-2.4304-1.61091-3.8891-1.61091-1.45869 0-2.85764.57946-3.88909 1.61091s-1.61091 2.4304-1.61091 3.88909c0 1.4587.57946 2.8576 1.61091 3.8891 1.03145 1.0314 2.4304 1.6109 3.88909 1.6109z'/%3E%3C/svg%3E")`
    )}
    ${redundantCssFromKebab("background-position", "1rem center")}
    ${redundantCssFromKebab("background-repeat", "no-repeat")}
    ${redundantCssFromKebab("background-size", "1rem 1rem")}
    ${redundantCssFromKebab("border", `${borderCSS}`)}
    ${redundantCssFromKebab("border-radius", `${radius.button}`)}
    ${redundantCssFromKebab("color", `${colorCSS("N900")}`)}
    ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
    ${redundantCssFromKebab("max-width", "22rem")}
    ${redundantCssFromKebab("padding", "0.5rem 0.45rem 0.5rem 2.5rem")}
    ${redundantCssFromKebab("width", "100%")}
    &::placeholder {
        ${redundantCssFromKebab("color", `${colorCSS("N400")}`)}
    }
`;

export const Stack = styled.div`
    ${redundantCssFromKebab("display", "grid")}
    ${redundantCssFromKebab("gap", "1.5rem")}
    ${redundantCssFromKebab("justify-items", "center")}
    @media ${minWidth.md} {
        ${redundantCssFromKebab("gap", "2.5rem")}
    }
`;

export const Table = styled.table`
    ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
    ${redundantCssFromKebab("width", "100%")}
    p {
        ${redundantCssFromKebab("margin", "0")}
    }
    th,
    th p:first-child {
        ${redundantCssFromKebab("font-weight", "500")}
        ${redundantCssFromKebab("text-transform", "uppercase")}
    }
    th:first-child {
        ${redundantCssFromKebab("text-align", "left")}
    }
    th,
    td {
        ${redundantCssFromKebab("display", "grid")}
        ${redundantCssFromKebab("gap", "0.25rem")}
        ${redundantCssFromKebab("padding", "0")}
    }
    thead {
        ${redundantCssFromKebab("display", "none")}
    }
    tbody {
        tr {
            ${redundantCssFromKebab("border-top", `${borderCSS}`)}
            ${redundantCssFromKebab("display", "grid")}
            ${redundantCssFromKebab("gap", "0.5rem")}
            ${redundantCssFromKebab("padding", "1.25rem 0")}
        }
        th {
            ${redundantCssFromKebab("font-weight", "400")}
            ${redundantCssFromKebab("text-transform", "none")}

            /* Lozenge */
            span {
                ${redundantCssFromKebab(
                    "background-color",
                    `${colorCSS("trelloblue")}`
                )}
                ${redundantCssFromKebab("border-radius", "0.25rem")}
                ${redundantCssFromKebab("color", `${colorCSS("N0")}`)}
                ${redundantCssFromKebab("display", "inline-block")}
                ${redundantCssFromKebab("font-size", `${fontSizes.xxs}`)}
                ${redundantCssFromKebab("font-weight", "normal")}
                ${redundantCssFromKebab("margin-left", "0.5rem")}
                ${redundantCssFromKebab("padding", "0.125rem 0.5rem")}
                ${redundantCssFromKebab("text-transform", "uppercase")}
                ${redundantCssFromKebab("vertical-align", "top")}
                ${redundantCssFromKebab("white-space", "nowrap")}
            }
        }
        td {
            ${redundantCssFromKebab("font-size", `${fontSizes.xxs}`)}
            ${redundantCssFromKebab("font-weight", "500")}
            ${redundantCssFromKebab("grid-template-columns", "50% 50%")}
            ${redundantCssFromKebab("place-items", "center end")}
            ${redundantCssFromKebab("text-transform", "uppercase")}
            &[data-appearance] {
                ${redundantCssFromKebab("background-position", "center right")}
                ${redundantCssFromKebab("background-repeat", "no-repeat")}
                ${redundantCssFromKebab("overflow", "hidden")}
                ${redundantCssFromKebab("text-indent", "100%")}
                ${redundantCssFromKebab("white-space", "nowrap")}
                &[data-appearance="Check"] {
                    ${redundantCssFromKebab(
                        "background-image",
                        `url("data:image/svg+xml,%3Csvg fill='${svgG300}' height='10' viewBox='0 0 14 10' width='14' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m1.73534 4.3223c-.37429-.40612-1.006926-.43192-1.41304-.05763-.4061134.37428-.431915 1.00692-.057629 1.41303l3.612109 3.91927c.53753.52613 1.33768.52613 1.83436.02941.06126-.06015.06126-.06015.36425-.35811.29455-.28972.62275-.61271.97618-.96077 1.00987-.99447 2.01975-1.99061 2.96243-2.92273l.0403-.03988c1.6748-1.6562 2.9461-2.92124 3.6577-3.64266.3878-.39319.3834-1.026344-.0098-1.414177-.3932-.3878326-1.0263-.3834835-1.4141.009714-.7038.713543-1.9712 1.974673-3.6401 3.625043l-.04027.03982c-.94157.93105-1.95051 1.92626-2.95947 2.91984-.29042.286-.56377.55505-.81538.80259z'/%3E%3C/svg%3E")`
                    )}
                }
                &[data-appearance="Empty"] {
                    ${redundantCssFromKebab(
                        "background-image",
                        `url("data:image/svg+xml,%3Csvg fill='${svgN100}' viewBox='0 0 20 20' height='20' width='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z'%3E%3C/path%3E%3C/svg%3E")`
                    )}
                }
            }
            &::before {
                ${redundantCssFromKebab("content", "attr(data-product)")}
                ${redundantCssFromKebab("justify-self", "flex-start")}
                ${redundantCssFromKebab("text-indent", "0")}
            }
        }
    }

    @media ${minWidth.md} {
        // table
        ${redundantCssFromKebab("border-bottom", `${borderCSS}`)}

        th,
        td {
            ${redundantCssFromKebab("display", "table-cell")}
            ${redundantCssFromKebab("padding", "1.25rem 1rem")}
            ${redundantCssFromKebab("width", "13%")}
        }
        tr {
            ${redundantCssFromKebab("padding", "0")}
        }
        th:first-of-type {
            ${redundantCssFromKebab("padding-left", "0")}
            ${redundantCssFromKebab("width", "auto")}
        }
        thead {
            ${redundantCssFromKebab("background-color", `${colorCSS("N0")}`)}
            ${redundantCssFromKebab("display", "table-header-group")}
            ${redundantCssFromKebab(
                "inset-block-start",
                `${SMALL_NAV_PX_HEIGHT - 1}px`
            )}
            ${redundantCssFromKebab("position", "sticky")}
            ${redundantCssFromKebab("z-index", "1")}
            // Hack to create table borders when borders are collapsed
            ${redundantCssFromKebab(
                "box-shadow",
                `1px 0px 0px 0px ${colorCSS("N0")}`
            )}
            ${redundantCssFromKebab(
                "filter",
                `drop-shadow(0px 1px 0px ${colorCSS("N40")})`
            )}

            th {
                ${redundantCssFromKebab("padding-bottom", "0.75rem")}
            }
        }
        tbody {
            tr {
                ${redundantCssFromKebab("display", "table-row")}
            }
            th,
            td {
                ${redundantCssFromKebab("border-right", `${borderCSS}`)}
            }
            td {
                ${redundantCssFromKebab("text-align", "center")}
                &[data-appearance] {
                    ${redundantCssFromKebab(
                        "background-position",
                        "center center"
                    )}
                    ${redundantCssFromKebab("text-indent", "calc(100% + 2rem)")}
                    &[data-appearance="Empty"] {
                        ${redundantCssFromKebab("background-image", "none")}
                    }
                }
                &::before {
                    ${redundantCssFromKebab("content", "none")}
                }
            }
        }
    }

    @media ${minWidth.lg} {
        thead {
            ${redundantCssFromKebab(
                "inset-block-start",
                `${BIG_NAV_PX_HEIGHT - 1}px`
            )}
        }
    }
`;
